var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.476 9.689-.555-.97a.188.188 0 0 0-.256-.068l-1.188.693-1.835-5.067a1.498 1.498 0 0 0-1.427-1.04H7.059c-.813 0-1.535.525-1.786 1.3l-1.748 4.81-1.19-.694a.188.188 0 0 0-.256.068l-.556.968a.185.185 0 0 0 .068.253l1.416.825-.34.938a.668.668 0 0 0-.042.234v8.16c0 .369.276.666.616.666h1.584c.289 0 .54-.217.6-.522l.181-.884h12.787l.18.884c.064.305.313.523.6.523h1.585c.34 0 .617-.298.617-.666v-8.161a.67.67 0 0 0-.043-.234l-.34-.938 1.414-.825a.187.187 0 0 0 .07-.253zM6.187 14.555a.937.937 0 1 1 0-1.875.937.937 0 0 1 0 1.875zm9.094 1.757a.188.188 0 0 1-.188.188H8.906a.188.188 0 0 1-.188-.188v-1.968c0-.103.085-.188.188-.188h.937c.104 0 .188.085.188.188v.843h3.937v-.843c0-.103.085-.188.188-.188h.937c.104 0 .188.085.188.188v1.968zm2.531-1.757a.937.937 0 1 1 0-1.875.937.937 0 0 1 0 1.875zM5.156 9.797 6.86 5.112l.012-.03.009-.031a.186.186 0 0 1 .178-.13h10.022l1.767 4.876H5.156z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarSmile);
export default __webpack_public_path__ + "static/media/car-smile.dc0f83b69b850dbfcc247178c04cdc22.svg";
export { ForwardRef as ReactComponent };